import axios from "axios";

export const fetchExportTaskCounterSubmission = async (data: any) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.post(`${baseTaskUrl}/TaskCounterSubmission/export`, data, {
    responseType: "blob",
  });
};